import { render } from "./TradeTable.vue?vue&type=template&id=c15d380a&scoped=true&ts=true"
import script from "./TradeTable.vue?vue&type=script&lang=ts"
export * from "./TradeTable.vue?vue&type=script&lang=ts"

import "./TradeTable.vue?vue&type=style&index=0&id=c15d380a&scoped=true&lang=css"

import exportComponent from "D:\\projects\\wintick\\wintick-applets-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c15d380a"]])

export default __exports__